var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"small"},[(_vm.datacollection)?_c('pie-chart',{attrs:{"chart-data":_vm.datacollection}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }